<template>
  <div class="wapper">
    <el-container style="100%">
      <ProjectType @getPTypeId="getPTypeId"></ProjectType>
      <el-main style="background:#fff;margin-left:15px;">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input v-model="searchForm.keyword" placeholder="项目名称"></el-input>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchSubmit()">搜索</el-button>
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button type="primary" plain icon="el-icon-plus" @click="addSubmit">新增</el-button>
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
                @selection-change="handleSelectionChange"
            >
<!--              <el-table-column type="selection" width="55" align="center"></el-table-column>-->
              <el-table-column prop="projectId" label="展会ID" width="280" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.projectId }}</p>
                  <p>同步：{{ scope.row.syncTime }}-{{ scope.row.sync }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="admin" label="数量" width="100" align="center">
                <template slot-scope="scope">
                  <p>短信:{{ scope.row.smsTotal }}</p>
                  <p>二要素:{{ scope.row.verifyTotal }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="admin" label="项目经理/手机号" width="160" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.admin }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="enabled" label="状态" width="100" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.enabled == 0 ? '已禁用' : '已启用' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="StartDate" width="150" label="起止时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.startDate }}</p>
                  <p>{{ scope.row.endDate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
                  <el-button type="text" class="red" @click="handleDelete(scope.$index, scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditPManage :editShow="editShow" :editData="editData" @backFunStu="getFunStu"></EditPManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditPManage from "../../components/systemSetup/EditProjectManage";
import ProjectType from "../../components/systemSetup/tree/ProjectType";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        keyword: ""
      },
      url: localStorage.getItem('url').replace('/api', ''),
      editData: {},
      listShow: true,
      delVisible: false,
      project_Id: "",
      editShow: false,
      dataList: [],
      multipleSelection: [],
      ProjectTypeId: 0
    };
  },
  created() {
    this.searchSubmit();
  },
  methods: {
    // 获取数据
    getData() {
      var search = {
        name: this.searchForm.keyword,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        type: this.ProjectTypeId
      }
      this.$axios.post("/Project/Search", search).then(res => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data]
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData()
    },
    addSubmit() {
      this.project_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.project_Id = row.projectId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/Project/${this.project_Id}`).then(res => {
        if (res.data.hasError == false) {
          this.$message.success("删除成功");
          this.delVisible = false;
          this.searchSubmit();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleCloseVisible() {
      // this.teacher_id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.searchSubmit();
    },
    getPTypeId(id) {
      this.ProjectTypeId = id;
      this.searchSubmit();
    }
  },
  components: {
    EditPManage,
    ProjectType,
    DeleteDialog
  }
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 10px;
}

.table-wrap {
  margin-left: 10px;
  height: calc(100% - 50px);
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}
</style>